
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageAfterIn() {
      // 
      // controlla profilo
      if (!myApp.checkUser()) {
        this.$app.dialog.alert(lng.profileIncomplete, () => {
          this.$router.navigate('/profile/');
        });
      }
    },

    pageBeforeOut() {
      window.clearInterval(myApp.chatInterval);
    }

  },

  mounted() {
    const self = this;
    myApp.server.get('imc/item/' + this.$route.params.id).then(succ => {
      self.$setState({
        poi: succ
      });
    });
    this.getMessages();
  },

  data() {
    // controlla login
    if (!myApp.user || !myApp.user.id) {
      this.$app.panel.open('.panel-left');
      return;
    }

    return {
      lng: lng,
      person: {
        id: '',
        name: ''
      },
      poi: {
        images: [{
          url: 'static/avatar-1.svg'
        }],
        caption: 'Titolo del locale'
      },
      messages: []
    };
  },

  methods: {
    deleteMessages() {
      const app = this.$app;
      app.dialog.confirm(lng.deleteChatAlert, function () {
        const messages = app.messages.get('.messages'); // server -> delete chat
        // ...

        messages.clear();
      }, false);
    },

    getMessages() {
      const self = this;
      const id = this.$route.params.id;
      myApp.server.get('imc/chat/' + id).then(succ => {
        // console.log(succ);
        self.$setState({
          messages: succ
        }, self.createMessages); // cerca nuovi messaggi da leggere e modifica stato dei messaggi inviati ogni 10"

        myApp.chatInterval = window.setInterval(self.getNewMessages, 10000);
      }).catch(err => {
        console.log(err);
      });
    },

    createMessages() {
      var app = this.$app,
          $$ = this.$$,
          $ = this.$,
          self = this; // Init Messages

      var messages = app.messages.create({
        el: '.messages',
        // First message rule
        firstMessageRule: function (message, previousMessage, nextMessage) {
          // Skip if title
          if (message.isTitle) return false;
          /* if:
           - there is no previous message
           - or previous message type (send/received) is different
           - or previous message sender name is different
           */

          if (!previousMessage || previousMessage.type !== message.type || previousMessage.name !== message.name) return true;
          return false;
        },
        // Last message rule
        lastMessageRule: function (message, previousMessage, nextMessage) {
          // Skip if title
          if (message.isTitle) return false;
          /* if:
           - there is no next message
           - or next message type (send/received) is different
           - or next message sender name is different
           */

          if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
          return false;
        },
        // Last message rule
        tailMessageRule: function (message, previousMessage, nextMessage) {
          // Skip if title
          if (message.isTitle) return false;
          /* if (bascially same as lastMessageRule):
           - there is no next message
           - or next message type (send/received) is different
           - or next message sender name is different
           */

          if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
          return false;
        },
        scrollMessagesOnEdge: false,
        on: {
          change: function () {
            console.log('Textarea value changed');
          }
        }
      }); // Init Messagebar

      var messagebar = app.messagebar.create({
        el: '.messagebar',
        on: {
          focus: function () {
            window.setTimeout(function () {
              $('#icon-message-send').removeClass('hidden');
              $('#icon-message-voice').addClass('hidden');
            }, 600);
          },
          blur: function () {
            window.setTimeout(function () {
              $('#icon-message-voice').removeClass('hidden');
              $('#icon-message-send').addClass('hidden');
            }, 300);
          }
        }
      }); //messagebar.focus();
      // Response flag

      var responseInProgress = false; // Send Message Text

      $$('.send-link').on('click', function () {
        var text = messagebar.getValue().replace(/\n/g, '<br>').trim(); // return if empty message

        if (!text.length) return; // Clear area

        messagebar.clear(); // Return focus to area

        messagebar.focus(); // Add message to messages

        const $id = new Date().getTime() + '@' + (Math.floor(Math.random() * (9999 - 1000)) + 1000);
        messages.addMessage({
          text: text,
          // string or <audio>...</audio>\
          type: 'sent',
          attrs: {
            'data-id': $id
          }
          /*    
           * image: <img ... /> or <video>...</video>
           * header: $datetime
           * footer: $check (if sent)
           * name: not used
           * avatar: not used
           * type: 'sent' | 'received'
           * textHeader: $actions
           * textFooter: not used
           * isTitle: boolean -> (if true) text = $datetime
           * cssClass: not used
           * attrs: object {
           *  'data-id': $id,
           *  ...
           *  }
           * 
           */

        }); // server -> sendMessage

        myApp.server.post('imc/chat', {
          type: 'text',
          id: $id,
          idpoi: self.$route.params.id,
          message: text
        }).then(succ => {
          //console.log(succ);
          const el = $('[data-id="' + $id + '"]');
          if (!el) return;
          const footer = el.find('.message-footer');
          const html = '<div class="message-footer"><i class="message-check f7-icons">checkmark</i></div>';

          if (footer.length == 0) {
            el.find('.message-content').append(html);
          } else {
            footer.html('<i class="message-check f7-icons">checkmark</i>');
          }
        }).catch(err => {
          console.log(err);
        });
      });
    },

    getNewMessages: function () {
      const app = this.$app,
            $ = this.$,
            self = this;
      const id = this.$route.params.id;
      const messages = app.messages.get('.messages'); // server -> getNewMessages

      myApp.server.get('imc/chat/' + id + '/_new').then(succ => {
        //console.log(succ);
        for (let i in succ) {
          if (succ[i].msgtype == 'received') {
            const msg = self.message(succ[i]);
            messages.addMessage(msg);
          } else {
            const el = $('[data-id="' + succ[i].id + '"]');

            if (!el[0]) {
              return console.log('Not element');
            }

            const footer = el.find('.message-footer');
            const html = '<div class="message-footer"><i class="message-check read f7-icons">checkmark</i> <i class="message-check read f7-icons">checkmark</i></div>';

            if (footer.length == 0) {
              el.find('.message-content').append(html);
            } else {
              footer.html('<i class="message-check read f7-icons">checkmark</i> <i class="message-check read f7-icons">checkmark</i>');
            }
          }
        }
      }).catch(err => {
        console.log(err);
      });
    },

    message(msg) {
      // formatta il messaggio per essere visualizzato in messages.addMessage();
      return {
        text: msg.text,
        // string or <audio>...</audio>\
        type: msg.msgtype,
        attrs: {
          'data-id': msg.id
        }
      };
    },

    getOldMessages: function () {// ...
    },
    deleteMessage: function (id) {
      this.$app.dialog.alert('Funzione in allestimento');
    },

    videoFromCamera() {
      if (window.cordova) {
        const self = this;
        const id = new Date().getTime() + '@' + (Math.floor(Math.random() * (9999 - 1000)) + 1000);
        myApp.cordova.captureVideo().then(mediaFile => {
          return self.addVideoMessage(mediaFile, id);
        }).then(myApp.cordova.uploadFile).then(src => {
          return myApp.server.post('imc/chat', {
            type: 'video',
            id: id,
            idpoi: self.$route.params.id,
            message: src
          });
        }).then(succ => {
          // console.log(succ);
          self.$app.preloader.hide();
          return new Promise((resolve, reject) => {
            const $ = this.$,
                  self = this,
                  app = this.$app;
            const el = $('[data-id="' + id + '"]');
            if (!el) reject('No element');
            const footer = el.find('.message-footer');
            const html = '<div class="message-footer"><i class="message-check f7-icons">checkmark</i></div>';

            if (footer.length == 0) {
              el.find('.message-content').append(html);
            } else {
              footer.html('<i class="message-check f7-icons">checkmark</i>');
            }

            resolve();
          });
        }).catch(err => {
          console.log(err);
          self.$app.preloader.hide();
          self.$app.toast.show({
            text: lng.genericError,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        });
      } else {
        this.$app.dialog.alert('Funzione non disponibile nel browser web');
      }
    },

    videoFromGallery() {
      if (window.cordova) {
        const self = this;
        const id = new Date().getTime() + '@' + (Math.floor(Math.random() * (9999 - 1000)) + 1000);
        myApp.cordova.videoGallery(id).then(mediaFile => {
          return self.addVideoMessage(mediaFile, id);
        }).then(myApp.cordova.uploadFile).then(src => {
          return myApp.server.post('imc/chat', {
            type: 'video',
            id: id,
            idpoi: self.$route.params.id,
            message: src
          });
        }).then(succ => {
          // console.log(succ);
          self.$app.preloader.hide();
          return new Promise((resolve, reject) => {
            const $ = this.$,
                  self = this,
                  app = this.$app;
            const el = $('[data-id="' + id + '"]');
            if (!el) reject('No element');
            const footer = el.find('.message-footer');
            const html = '<div class="message-footer"><i class="message-check f7-icons">checkmark</i></div>';

            if (footer.length == 0) {
              el.find('.message-content').append(html);
            } else {
              footer.html('<i class="message-check f7-icons">checkmark</i>');
            }

            resolve();
          });
        }).catch(err => {
          console.log(err);
          self.$app.preloader.hide();
          self.$app.toast.show({
            text: lng.genericError,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        });
      } else {
        this.$app.dialog.alert('Funzione non disponibile nel browser web');
      }
    },

    addVideoMessage(mediaFile, id) {
      const app = this.$app,
            $ = this.$;
      self = this;
      return new Promise((resolve, reject) => {
        const messages = this.$app.messages.get('.messages');
        const $id = id;
        messages.addMessage({
          text: '',
          // string or <audio>...</audio>\
          type: 'sent',
          image: '<video controls preload="metadata" src="' + mediaFile.fullPath + '#t=0.5" type="' + mediaFile.type + '"></video>',
          attrs: {
            'data-id': $id
          }
        });
        app.preloader.show();
        resolve(mediaFile);
      });
    },

    addAudioMessage(mediaFile, id) {
      console.log('addAudioMessage'); //console.log(mediaFile);

      const app = this.$app,
            $ = this.$;
      self = this;
      return new Promise((resolve, reject) => {
        const messages = this.$app.messages.get('.messages');
        const $id = id;
        messages.addMessage({
          text: '<audio controls preload="metadata" src="' + mediaFile.fullPath + '" type="' + mediaFile.type + '"></audio>',
          type: 'sent',
          attrs: {
            'data-id': $id
          }
        });
        app.preloader.show();
        resolve(mediaFile);
      });
    },

    photoFromCamera() {
      const self = this;

      if (window.cordova) {
        myApp.cordova.camera().then(self.sendImage);
      } else {
        this.$app.dialog.alert('Funzione non disponibile nel browser web');
      }
    },

    photoFromGallery() {
      const self = this;

      if (window.cordova) {
        myApp.cordova.camera('gallery').then(self.sendImage);
      } else {
        this.$app.dialog.alert('Funzione non disponibile nel browser web');
      }
    },

    audio() {
      if (window.cordova) {
        const self = this;
        const id = new Date().getTime() + '@' + (Math.floor(Math.random() * (9999 - 1000)) + 1000);
        myApp.cordova.captureAudio().then(mediaFile => {
          return self.addAudioMessage(mediaFile, id);
        }).then(myApp.cordova.uploadAudio).then(src => {
          return myApp.server.post('imc/chat', {
            type: 'audio',
            id: id,
            idpoi: self.$route.params.id,
            message: src
          });
        }).then(succ => {
          //console.log(succ);
          self.$app.preloader.hide();
          return new Promise((resolve, reject) => {
            const $ = this.$,
                  self = this,
                  app = this.$app;
            const el = $('[data-id="' + id + '"]');
            if (!el) reject('No element');
            const footer = el.find('.message-footer');
            const html = '<div class="message-footer"><i class="message-check f7-icons">checkmark</i></div>';

            if (footer.length == 0) {
              el.find('.message-content').append(html);
            } else {
              footer.html('<i class="message-check f7-icons">checkmark</i>');
            }

            resolve();
          });
        }).catch(err => {
          console.log(err);
          self.$app.preloader.hide();
          self.$app.toast.show({
            text: lng.genericError,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        });
      } else {
        this.$app.dialog.alert('Funzione non disponibile nel browser web');
      }
    },

    sendImage(src) {
      const app = this.$app,
            $ = this.$,
            self = this;
      const $id = new Date().getTime() + '@' + (Math.floor(Math.random() * (9999 - 1000)) + 1000);
      const messages = app.messages.get('.messages');
      messages.addMessage({
        text: '',
        // string or <audio>...</audio>\
        type: 'sent',
        image: '<img src="' + src + '"/>',
        attrs: {
          'data-id': $id
        }
      });
      myApp.server.post('imc/image', {
        src: src
      }).then(resp => {
        return myApp.server.post('imc/chat', {
          type: 'image',
          id: $id,
          idpoi: self.$route.params.id,
          message: resp.src
        });
      }).then(succ => {
        //console.log(succ);
        const el = $('[data-id="' + $id + '"]');
        if (!el) return;
        const footer = el.find('.message-footer');
        const html = '<div class="message-footer"><i class="message-check f7-icons">checkmark</i></div>';

        if (footer.length == 0) {
          el.find('.message-content').append(html);
        } else {
          footer.html('<i class="message-check f7-icons">checkmark</i>');
        }
      }).catch(err => {
        console.log(err);
        self.$app.toast.show({
          text: lng.genericError,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      });
    }

  },
  id: '0d54bf2d9e',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            &nbsp;\n            <div class="message-avatar-title" style="background-image:url(';
      r += c(ctx_1.poi.avatar, ctx_1);
      r += ');"></div>\n          </a>\n        </div>\n        <div class="title">';
      r += c(ctx_1.poi.caption, ctx_1);
      r += '</div>\n        <!-- <div class="right">\n          <a href="#" @click="deleteMessages" class="link">\n            <i class="icon icon-small f7-icons">trash</i>\n          </a>\n        </div> -->\n      </div>\n    </div>\n    <div class="toolbar messagebar">\n      <hr class="ios-only" style="border: none; border-top: solid 1px #ddd; margin:0; padding:0">\n      <div class="toolbar-inner">  \n        <a href="#" data-popover=".messages-plus" class="popover-open">\n          <i class="icon material-icons text-color-imc">add</i>\n        </a>\n        &nbsp;&nbsp;\n        <div class="messagebar-area">\n          <textarea class="resizable" placeholder="';
      r += c(ctx_1.lng.message, ctx_1);
      r += '"></textarea>\n        </div>\n        <a id="icon-message-send" class="link send-link hidden" href="#">\n          <i class="icon material-icons text-color-imc ">send</i>\n        </a>\n        <a id="icon-message-voice" class="link" href="#" @click="audio">\n          <i class="icon material-icons text-color-imc">keyboard_voice</i>\n        </a>\n      </div>\n    </div>\n    <div class="page-content messages-content">\n      <div class="messages">\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.messages, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class="message message-';
          r += c(ctx_2.msgtype, ctx_2);
          r += '" data-id="';
          r += c(ctx_2.id, ctx_2);
          r += '">\n          <div class="message-content">\n            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.datetime, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' \n            <div class="message-header">';
              r += Template7Helpers.js.call(ctx_3, "new Date(this.datetime).toLocaleString()", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div>\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            <div class="message-bubble">\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.type=='text'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="message-text">';
              r += c(ctx_3.text, ctx_3);
              r += '</div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.type=='image'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="message-image">\n                <img src="';
              r += c(ctx_3.src, ctx_3);
              r += '" data-idx="';
              r += c(data_3 && data_3.index, ctx_3);
              r += '">\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.type=='audio'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="message-text">\n                <audio id="audio-';
              r += c(ctx_3.id, ctx_3);
              r += '"\n                       controls>\n                  <source src="';
              r += c(ctx_3.src, ctx_3);
              r += '" type="';
              r += c(ctx_3.mime, ctx_3);
              r += '"> \n                </audio>\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.type=='video'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="message-image">\n                <video id="video-';
              r += c(ctx_3.id, ctx_3);
              r += '"\n                       controls poster="';
              r += c(ctx_3.poster, ctx_3);
              r += '" \n                       webkit-playsinline \n                       preload="metadata">\n                  <source src="';
              r += c(ctx_3.src, ctx_3);
              r += '" type="';
              r += c(ctx_3.mime, ctx_3);
              r += '"> \n                </video>\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            <div class="message-footer">\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.status=='sent' && this.msgtype=='sent'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <i class="message-check f7-icons">checkmark</i>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.status=='received' && this.msgtype=='sent'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <i class="message-check f7-icons">checkmark</i>\n              <i class="message-check f7-icons">checkmark</i>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.status=='read' && this.msgtype=='sent'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <i class="message-check read f7-icons">checkmark</i>\n              <i class="message-check read f7-icons">checkmark</i>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.status=='error' && this.msgtype=='sent'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <i class="message-check error f7-icons">xmark_circle_fill</i>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.msgtype=='received'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div>&nbsp;</div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n          </div>\n        </div>\n\n        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n        <div class="card" style="background-color: #fffae3;">\n          <div class="card-content card-content-padding" style="color:#ab6234">\n            ';
          r += c(ctx_2.lng.chatNewMessage, ctx_2);
          r += '\n          </div>\n        </div>\n\n        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n      </div>\n    </div>\n\n    <div class="popover messages-plus">\n      <div class="popover-inner">\n        <div class="list">\n          <ul>\n            <li>\n              <a href="#" @click="photoFromCamera" class="item-link popover-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons">camera</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      Photo\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="photoFromGallery" class="item-link popover-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons">photo_on_rectangle</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      Image from gallery\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="videoFromCamera" class="item-link popover-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons">videocam</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      Video\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n            <li>\n              <a href="#" @click="videoFromGallery" class="item-link popover-close">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon f7-icons">film</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-title">\n                      Video from gallery\n                    </div>\n                  </div>\n                </div>\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    